/* eslint-disable jsx-a11y/no-autofocus */
import { FC, useState, ChangeEvent, KeyboardEvent } from 'react';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';

import styles from './InputSearch.module.sass';

interface InputSearchProps {
  id: string;
  name: string;
  value: string;
  onChange: any;
  onSearch: () => void;
  className?: string;
  placeholder?: string;
  disabled?: boolean;
  readOnly?: boolean;
  required?: boolean;
  autoFocus?: boolean;
  expandable?: boolean;
  isError?: boolean;
}

const InputSearch: FC<InputSearchProps> = (props) => {
  const {
    id,
    name,
    value,
    onChange,
    onSearch,
    className = '',
    placeholder = '',
    disabled = false,
    readOnly = false,
    required = false,
    autoFocus = false,
    expandable = false,
    isError = false,
  } = props;

  const { t } = useTranslation();
  const [focused, setFocused] = useState(false);

  const changeHandler = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  const clickHandler = () => {
    onSearch();
  };

  const focusHandler = () => {
    setFocused(true);
  };

  const blurHandler = () => {
    setFocused(false);
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    // Using `key` and `code` instead of `keyCode` which is deprecated.
    if (e.key === 'Enter' && e.code === 'Enter') {
      onSearch();
    }
  };

  const wrapperClassName = cx(
    className,
    styles.search,
    isError && styles.error,
    expandable && (focused || value.length > 0) && styles.expanded,
  );

  return (
    <div className={wrapperClassName}>
      <div className={styles.inner}>
        <input
          id={id}
          name={name}
          type="search"
          className={styles.input}
          value={value}
          onChange={changeHandler}
          onBlur={blurHandler}
          onFocus={focusHandler}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          disabled={disabled}
          readOnly={readOnly}
          required={required}
          autoFocus={autoFocus}
        />
      </div>
      <button
        type="button"
        className={styles.button}
        onClick={clickHandler}
        disabled={readOnly || disabled}
      >
        {t('translation.btn_search_title')}
      </button>
    </div>
  );
};

export default InputSearch;
